export const LawyerCard = {
  extends: 'Link',
  href: (el, s) => '/lawyer?id=' + s.id,
  textDecoration: 'none',
  color: 'inherit',
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  theme: 'card',
  cursor: 'pointer',
  transition: 'all 0.25s ease',
  border: (el, s) => s.isSubscribed ? '1px solid green.3' : '1px solid transparent',
  ':hover': { boxShadow: 'black.08 0 Z B', transform: 'translateY(-2px)' },

  CardHeader: {
    flow: 'x',
    align: 'flex-start space-between',
    gap: 'A',
    HeaderLeft: {
      flow: 'x',
      align: 'flex-start flex-start',
      gap: 'A',
      flex: '1',
      minWidth: '0',
      LawyerAvatar: {
        tag: 'img',
        width: 'C',
        height: 'C',
        round: 'C',
        flexShrink: '0',
        objectFit: 'cover',
        src: (el, s) => s.photoUrl || s.avatar || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn) + '&background=1a2332&color=c6ac8f&size=96&bold=true&format=svg'
      },
      NameGroup: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        LawyerName: { text: (el, s) => s.nameEn, fontSize: 'A', fontWeight: '600', letterSpacing: '-0.01em' },
        LawyerNameKa: { text: (el, s) => s.nameKa, fontSize: 'Z', opacity: '0.6' },
        FirmRow: {
          flow: 'x', gap: 'Y', align: 'center',
          LawyerFirm: {
            text: (el, s) => s.firmNameEn || 'Independent',
            fontSize: 'Z',
            opacity: '0.5',
            fontStyle: (el, s) => s.firmNameEn ? 'normal' : 'italic'
          },
          VerifiedBadge: {
            show: (el, s) => s.isSubscribed,
            text: '\u2605 Verified',
            fontSize: 'X',
            fontWeight: '700',
            color: 'green',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            padding: 'V Y',
            background: 'greenBg',
            round: 'W',
          },
        }
      }
    },
    StatusRating: {
      flow: 'y',
      gap: 'Z',
      align: 'flex-end flex-end',
      flexShrink: '0',
      RatingBadge: {
        flow: 'x',
        gap: 'Y',
        align: 'center center',
        padding: 'Y Z',
        round: 'Z',
        theme: 'success',
        show: (el, s) => s.reviews > 40,
        RatingStar: { text: '\u2605', fontSize: 'Z' },
        RatingVal: { text: (el, s) => String(s.rating), fontSize: 'Z', fontWeight: '600' }
      },
      StatusBadge: {
        flow: 'x',
        gap: 'Y',
        align: 'center center',
        StatusDot: {
          width: 'Y',
          height: 'Y',
          borderRadius: '100%',
          background: (el, s) => s.status === 'active' ? 'green' : 'red',
        },
        StatusText: {
          text: (el, s) => s.status,
          fontSize: 'Z',
          fontWeight: '500',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: (el, s) => s.status === 'active' ? 'green' : 'red',
        },
      }
    }
  },

  CardMeta: {
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    align: 'center flex-start',
    marginTop: 'Z',
    opacity: '0.6',
    fontSize: 'Z',
    MetaCity: { text: (el, s) => s.city },
    MetaDot1: { text: '\u00B7' },
    MetaReviews: { text: (el, s) => s.reviews + ' reviews' },
    MetaDot2: { text: '\u00B7' },
    MetaBarId: { text: (el, s) => s.barId }
  },

  CardSpecializations: {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    marginTop: 'Z',
    children: (el, s) => (s.specializations || []).slice(0, 3).map(sp => ({ label: sp })),
    childrenAs: 'state',
    childProps: {
      text: (el, s) => s.label,
      fontSize: 'Z',
      padding: 'Y Z',
      round: 'C',
      theme: 'secondary',
      fontWeight: '500'
    }
  }
}
